module.exports = __webpack_public_path__ + "static/media/IMG_3521-min.3145c793.JPG";